module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_b/logo-aoj-zh-hant-004721e12a44b484f53f34dcfbd10b3e.svg";